import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import { languageActions } from 'actions/api/languages';
import MaterialTextField from 'components/util/materialTextField';
import MaterialSelect from 'components/util/materialSelect';
import { reduxForm, Field } from 'redux-form';
import { validate } from 'reducers/form/validate';
import { RaisedButton } from 'material-ui';
import Moment from 'react-moment';
import { getLanguageCodes } from 'actions/api/config';
import MaterialCheckbox from 'components/util/materialCheckbox';
import StrictInlineInput from 'components/util/strictInlineInput';

class ManageLanguages extends Component {
  state = { languageOptions: [] };

  async componentWillMount() {
    this.props.dispatch(languageActions.search({}));
    const res = await getLanguageCodes();
    const options = res.data.map(code => {
      return {
        label: `${code.code} (${code.name})`,
        value: code.code
      };
    });
    this.setState({ languageOptions: options });
  }

  onSave = fields => {
    this.props.dispatch(languageActions.save({ data: fields }));
    this.props.reset();
  };

  updateActiveState = (id, val, field) => {
    this.props.dispatch(
      languageActions.save({ data: { id, [field]: val }, background: true })
    );
  };

  updateTitle = (id, val) => {
    this.props.dispatch(
      languageActions.save({
        data: { id, title_english: val },
        background: true
      })
    );
  };

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div>Manage Languages</div>
          <div className={styles.help}>
            <b>Help:</b>{' '}
            <a
              href="http://www.lingoes.net/en/translator/langcode.htm"
              target="_blank"
              rel="noopener noreferrer">
              Codes
            </a>
            {' or '}
            <a
              href="https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2"
              target="_blank"
              rel="noopener noreferrer">
              Alpha2
            </a>
          </div>
          <div />
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <form onSubmit={this.props.handleSubmit(this.onSave)}>
              <div className="row">
                <div className="col-3">
                  <Field
                    component={MaterialTextField}
                    name="title_english"
                    hintText="Title*"
                    noValidate
                  />
                </div>
                <div className="col-3">
                  <Field
                    component={MaterialSelect}
                    name="google_translate_key"
                    hintText="Google Code*"
                    options={this.state.languageOptions}
                    noValidate
                  />
                </div>
                <div className="col-3">
                  <Field
                    component={MaterialTextField}
                    name="code"
                    hintText="Full Code*"
                    noValidate
                  />
                </div>
                <div className="col-3">
                  <div className={styles.submitWrapper}>
                    <Field
                      component={MaterialTextField}
                      name="alpha2"
                      hintText="Alpha2*"
                      noValidate
                    />
                    <div>
                      <RaisedButton
                        label="Save"
                        type="submit"
                        primary
                        disabled={!this.props.valid}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.tableWrapper}>
            <div className={styles.headerWrapper}>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: '80px' }}>Complete</th>
                    <th>Title</th>
                    <th>Google Code</th>
                    <th>Full Code</th>
                    <th>Alpha2</th>
                    <th>Creation Date</th>
                    <th style={{ textAlign: 'center' }}>App Strings?</th>
                    <th style={{ textAlign: 'center' }}>
                      Classification Strings?
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className={styles.bodyWrapper}>
              <table>
                <tbody>
                  {this.props.languages
                    .sort((a, b) =>
                      a.title_english.localeCompare(b.title_english)
                    )
                    .map(language => {
                      return (
                        <tr key={language.id}>
                          <td style={{ width: '80px' }}>
                            {language.percent_translated.toFixed(2)}%
                          </td>
                          <td>
                            <StrictInlineInput
                              value={language.title_english}
                              onBlur={val => this.updateTitle(language.id, val)}
                            />
                          </td>
                          <td>{language.google_translate_key}</td>
                          <td>{language.code}</td>
                          <td>
                            <div
                              style={{
                                backgroundSize: 'contain',
                                backgroundPosition: '50%',
                                backgroundRepeat: 'no-repeat',
                                width: 34,
                                height: 26,
                                verticalAlign: 'middle',
                                marginRight: '10px'
                              }}
                              className={`img-thumbnail flag flag-icon-background flag-icon-${language.alpha2}`}
                            />
                            {language.alpha2}
                          </td>
                          <td>
                            {<Moment fromNow>{language.created_at}</Moment>}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <MaterialCheckbox
                              value={language.app_strings_active}
                              onChange={(e, val) => {
                                this.updateActiveState(
                                  language.id,
                                  val,
                                  'app_strings_active'
                                );
                              }}
                            />
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <MaterialCheckbox
                              value={language.classification_strings_active}
                              onChange={(e, val) => {
                                this.updateActiveState(
                                  language.id,
                                  val,
                                  'classification_strings_active'
                                );
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validations = {
  required: {
    fields: ['title_english', 'code', 'google_translate_key', 'alpha2']
  }
};

ManageLanguages = reduxForm({
  form: 'ManageLanguages',
  validate: values => {
    return validate(values, validations);
  }
})(ManageLanguages);

export default connect(state => {
  return { languages: state.languages.list };
})(ManageLanguages);



// WEBPACK FOOTER //
// ./src/components/dashboard/developerDashboard/manageLanguages/index.js